// Routes match the old Wix site's URLs so existing links & search results keep working
export const PAGE_ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  CURTAINS: "/curtains",
  SHOP: "/shop",
  PRODUCT: "/product-page/:productSlug",
  OUR_WORK: "/our-work",
  FAQ: "/faq",
  FABRIC_CARE: "/fabric-care",
  SHIPPING: "/shipping-returns",
  CONTACT: "/contact",
  BLOG: "/blog",
  POST: "/post/:postSlug",
  TERMS: "/terms",
  //Replace the old Google Forms (upholstery & restoration / curtains & blinds)
  QUOTE: "/request-a-quote",
  CURTAINS_QUOTE: "/request-a-quote/curtains",
  CART: "/cart-page",
  ORDER_RESULT: "/order/:result",
  //Service & curtain pages (data/sectionPages.js) and shop categories (SHOP_CATEGORIES)
  PAGE: "/:pageSlug",
};

export const getProductRoute = (slug) => (
  PAGE_ROUTES.PRODUCT.replace(":productSlug", slug)
);

export const getPostRoute = (slug) => (
  PAGE_ROUTES.POST.replace(":postSlug", slug)
);

// The shop categories with their Wix page URLs. A product's Category field lists the ones it's in ("Decor, Home
// Accessories"). inMenu: in the Shop dropdown (Home Accessories only shows in the shop filter, as on Wix).
export const SHOP_CATEGORIES = [
  { name: "Furniture", slug: "furniture", inMenu: true },
  { name: "Decor", title: "Décor", slug: "decor", inMenu: true },
  { name: "Curtains", slug: "curtains-shop", inMenu: true },
  { name: "Carpets", slug: "carpets", inMenu: true },
  { name: "Bedding", slug: "bedding", inMenu: true },
  { name: "Bathroom Necessities", slug: "bathroom-necessities", inMenu: true },
  { name: "Upholstery products", title: "Upholstery Products", slug: "upholstery-products", inMenu: true },
  { name: "Home Accessories", slug: "home-accessories", inMenu: false },
];

export const CONTACT_DETAILS = {
  PHONE: "012 663 1070",
  PHONE_LINK: "tel:+27126631070",
  CELL: "060 644 6378",
  CELL_LINK: "tel:+27606446378",
  WHATSAPP: "https://wa.me/27606446378",
  EMAIL: "showroom@creatorstudio.co.za",
  ADDRESS: "Unit C, 18 Eland Street, Koedoespoort Industrial, Pretoria",
  FACEBOOK: "https://www.facebook.com/creators.studio.za",
  INSTAGRAM: "https://www.instagram.com/creators_studio_za/",
  TAPX: "http://www.tap-x.com/",
};

export const ADMIN_PAGE_ROUTES = {
  HOME: "/admin",
  ORDERS: "/admin/orders",
  ORDER: "/admin/orders/:orderID",
  PRODUCTS: "/admin/products",
  PRODUCT: "/admin/products/:productID",
  QUOTES: "/admin/quotes",
  QUOTE: "/admin/quotes/:quoteID",
  BLOG: "/admin/blog",
  POST: "/admin/blog/:postID",
  GALLERY: "/admin/gallery",
  SETTINGS: "/admin/settings",
  ANALYTICS: "/admin/analytics",
  ACCOUNT: "/admin/account",
};

export const getAdminQuoteRoute = (quoteID) => (
  ADMIN_PAGE_ROUTES.QUOTE.replace(":quoteID", quoteID)
);

//"new" opens an empty post
export const getAdminPostRoute = (postID) => (
  ADMIN_PAGE_ROUTES.POST.replace(":postID", postID)
);

export const getAdminOrderRoute = (orderID) => (
  ADMIN_PAGE_ROUTES.ORDER.replace(":orderID", orderID)
);

//"new" opens an empty product form
export const getAdminProductRoute = (productID) => (
  ADMIN_PAGE_ROUTES.PRODUCT.replace(":productID", productID)
);

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  LOGIN: "ls_1",
  CONTACT_SEND: "ls_2",
  CHECKOUT: "ls_3",
  ORDER_STATUS: "ls_4",
  PRODUCTS: "ls_5",
  QUOTE_SEND: "ls_6",
};

export const LS_ITEM_ADMIN = {
  SUMMARY_LOAD: "lsa_1",
  ORDERS_LOAD: "lsa_2",
  ORDER_LOAD: "lsa_3",
  ORDER_SAVE: "lsa_4",
  EXPORT: "lsa_5",
  PASSWORD_SAVE: "lsa_6",
  PRODUCTS_LOAD: "lsa_7",
  PRODUCT_LOAD: "lsa_8",
  PRODUCT_SAVE: "lsa_9",
  PRODUCT_DELETE: "lsa_10",
  IMAGES_UPDATE: "lsa_11",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  ERROR: 1,
  SUCCESS: 2,
};

export const PAYMENT_STATUS = {
  PENDING: "Pending",
  PAID: "Paid",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
  REFUNDED: "Refunded",
};

export const FULFILMENT_STATUS = {
  NEW: "New",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};

export const PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "North West",
  "Northern Cape",
  "Western Cape",
];
